import { Resolver } from '@blaze-cms/nextjs-tools';

export default Resolver;
